/**
 * weekly-period-selects
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

/* global Intl */

import getSelectedOptions from "../common/get-selected-options";

export default sb => {
    let periods;
    let yearSelect;
    let monthsSelect;

    const fetchPeriods = function fetchPeriods() {
        if (periods !== void 0) {
            return Promise.resolve(periods);
        }

        return sb.postApi("/whats-new/top-programmes-available-months").then(
            months => {
                //noinspection JSUnresolvedFunction
                let format = new Intl.DateTimeFormat("en-GB", { month: "long" });

                periods = months.reduce((acc, period) => {
                    let [year, month, day] = period.name.split(/-/);

                    year = parseInt(year, 10);
                    month = parseInt(month, 10);

                    acc[year] = acc[year] || [];


                    month = new Date(year, month - 1, day);

                    let name = format.format(month);

                    acc[year].push({ name, id: period.id });

                    return acc;
                }, {});

                return periods;
            }
        );
    };

    const populatePeriodsSelects = function populatePeriodsSelects(yearSelection) {
        return fetchPeriods().then(pds => {
            let selectedYear = yearSelection,
                selectedMonth;

            /* If the user has selected a year that isn't this year, select Jan
            for the month, otherwise it will default to the latest month. */
            if (selectedYear &&
                parseInt(selectedYear, 10) !== (new Date()).getUTCFullYear()
            ) {
                selectedMonth = pds[selectedYear][0];
            }

            // Years (in reverse order)
            sb.empty("#period_year")
                .append("#period_year", Object.keys(pds).reverse().map(
                    year => {
                        selectedYear = selectedYear || year;
                        let selected = year === selectedYear ? " selected" : "";
                        return `<option${selected} value="${year}">${year}</option>`;
                    }
                ).join("\n"));

            // Months: slice() to clone and reverse() to select the most recent month
            let monthOptions = pds[selectedYear].slice().reverse();
            monthOptions = monthOptions.map(month => {
                if (selectedMonth === void 0) {
                    selectedMonth = selectedMonth || month;
                }
                let selected = selectedMonth === month ? " selected" : "";

                return `<option${selected} value="${month.id}">${month.name}</option>`;
            });
            // Reverse again so they're displayed chronologically
            sb.empty("#period_month").append(
                "#period_month",
                monthOptions.reverse().join("\n")
            );

            onMonthsChange(); // We've added periods selected
        });
    };

    const onYearChange = function onYearChange() {
        populatePeriodsSelects(yearSelect[0].value);
    };

    const onMonthsChange = function onMonthChange() {
        sb.notify({
            type: "periodsSelectionChanged",
            data: [].map.call(
                getSelectedOptions(monthsSelect[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            yearSelect = sb.find("#period_year");
            monthsSelect = sb.find("#period_month");

            populatePeriodsSelects();

            sb.addEvent(yearSelect, "change", onYearChange);
            sb.addEvent(monthsSelect, "change", onMonthsChange);
        },
        destroy() {
            sb.removeEvent(monthsSelect, "change", onMonthsChange);
            sb.removeEvent(yearSelect, "change", onYearChange);

            periods = null;

            yearSelect = null;
            monthsSelect = null;
        }
    }
}
